import { createModel } from './model'
import { createSearch } from './search'
import { createList } from './list'
import { createEntity } from './entity'
import { merge } from 'lodash'

export function createResource(client, name, options = {}) {

  const resource = { client, name, options }

  resource.model = function(options) {
    return createModel(resource.client, resource.name, merge({}, resource.options, options))
  }

  resource.search = function(options) {
    return createSearch(resource.client, resource.name, merge({}, resource.options, options))
  }

  resource.list = function(options) {
    return createList(resource.client, resource.name, merge({}, resource.options, options))
  }

  resource.delete = function() {
    let ids = Array.from(arguments)
    return resource.client.delete(resource.name + (ids.length ? '/' + ids.join(',') : ''))
  }

  resource.entity = function(ids) {
    return createEntity(resource, ids && Array.isArray(ids) ? ids : Array.from(arguments), options)
  }

  resource.post = function(path, data, config) {
    return resource.client.post(resource.name + (path.length ? '/' + path : ''), data, config)
  }

  return resource

}